/**
 * Прореживание ряда графика.
 *
 * Витринный график робота — 365 точек на экране шириной 350px: рисовать их
 * все значит тратить кадры на пиксели, которых нет. Первая и последняя точки
 * сохраняются всегда — по ним читается период, и потеря края исказила бы
 * картину сильнее, чем прореживание середины.
 */
export function downsample<T>(points: readonly T[], target: number): T[] {
  if (target < 2 || points.length <= target) return [...points];

  const last = points.length - 1;
  const step = last / (target - 1);
  const result: T[] = [];

  for (let index = 0; index < target; index += 1) {
    const point = points[Math.round(index * step)];
    if (point !== undefined) result.push(point);
  }

  return result;
}
